import { Component, Inject, OnInit, Output, ViewChild, ElementRef, EventEmitter, Input } from '@angular/core';
import {ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SchoolService } from '../../service/school.service';
import { UserManagementService } from '../../../../../tools/src/service/user.management.service';
import { SchoolManagementService } from '../../service/schoolmanagement.service';

import { MyErrorHandler } from '../../../../../tools/src/lib/errorhandler/errorhandler';
// import { filter } from 'rxjs';
import { Dialog } from '@eds/vanilla';
import { Observable, forkJoin } from 'rxjs';


declare var jQuery;

@Component({
  selector: 'app-ctl-assign-teacher',
  templateUrl: './ctl.assign.teacher.component.html',
  styleUrls: ['./ctl.assign.teacher.component.css'],
  providers: [SchoolService, UserManagementService, SchoolManagementService]
})


export class CtlAssignTeacherComponent implements OnInit {
  loaded = false;
  assignedTeacherList = {};
  cteacher = '';
  csubject = '';
  linkClicked:boolean = false;
  @ViewChild('select') selectElRef;
  @Input() assignmentList: any[];
  @Input() refresh = false;
  @Input() myForm: any;
  @Input() complete:boolean;
  @Input() myTeachers = [];
 
  @Input() mySubjectList = [];
  @Output() assignDone: EventEmitter<boolean> = new EventEmitter();
  @Output() evOpenAssignTeacher: EventEmitter<any> = new EventEmitter();

  currentGrade = 0;
  project_id = '';
  school_id = '';
  grade_id = '';
  class_id = '';
  gradeList: any[] = [];
  subjectList: any[] = [];
  roleListData: any[] = [];
  page = 1;
  gradeCount = 1;
  classes = [];
  subjects = [];
  teachers = [];
  myModelProperty:any[] = [];
  mTeachers = [];
  mTeachers2 = [];
  gradeIndex = 0;
  classIndex = 0;
  prevGradeIndex = 0;
  prevClassIndex = 0;
  teacherClassMapping = [];
  lastRefresh = false;
  nextBtnClicked = false;
  btnText = 'Next Grade';
  backText = "Back"
  setupCompleted:boolean = false;
  selectTeacher = []
  selectedValues: any[] = [];
  selectedSubjectsList = [];
  
  isCancelSetup:boolean = false;
  schoolDetails:any = [];

  titleMessage="";
  detailMessage1="";
  detailMessage2="";
  subjectListId = [];
  

  curSubjectTeacher = [];

  curClass;
  currentClass:any;
  teacherSelectConfig: any;
  textDir:any;
  constructor(
    private schoolService: SchoolService,
    public translate: TranslateService,
    private userService: UserManagementService,
    private schoolManagementService:SchoolManagementService,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {
    // jQuery('[data-toggle="tooltip"]').tooltip();
    this.translate.get('Select').subscribe((translated: string) => {
      this.teacherSelectConfig = {
        placeholder: translated,
        displayKey: 'name',
        search: false,
        height: '150px',
        customComparator: (function(a, b) {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
    
          // names must be equal
          return 0;
        })
      };
    });
    const userData = JSON.parse(window.localStorage.getItem('loginInfoObj'));
    this.route.params.subscribe(params => {
      this.school_id = params['school_id'];
      if (params['project_id']) {
        this.project_id = params['project_id'];
        // this.getProjectData(this.project_id);
      }
      //console.log('school id ' + this.school_id);
      if (!this.school_id) {
        this.school_id = userData.school._id;
      }
      if (!this.project_id) {
        this.project_id = userData.project._id;
        console.log('project id ' + this.project_id);
      }
      //this.getSubjectList();
      // this.getRoleList();
      this.init();
      
      // this.getGradeClassList();
      // this.getTeacherList();
    });
    if (this.mySubjectList) {
        this.subjectList = this.mySubjectList;
    }
    this.gradeCount = 1;
    this.selectedValues=[];
    this.nextBtnClicked = false;
    this.btnText =  this.translate.instant('Next Grade');
  }

  log(data){
    console.log(data);
  }
  ngOnChanges(args: any[]) {
   // alert("ngonchange");
    let it=0;
    if(this.myForm.controls.subjectteacher.controls && this.subjectList){
      this.myForm.controls.subjectteacher.controls.forEach(element => {      
        this.subjectList.forEach( item => {
          if(element.get('subject').value && item){
            if(element.get('subject').value._id == item._id){
              this.mTeachers[it] = [...this.myTeachers];
              this.mTeachers2[it] = [...this.myTeachers];
              let k=0
              this.mTeachers2[it].forEach(tchr => {
                if(tchr._id == element.get('teacher').value._id){
                  this.mTeachers2[it].splice(k,1);
                }
                k++;
              });
            }
          }          
        });
        it++;
      });
    }
  }
  ngDoCheck() {
    /*if (this.refresh !== this.lastRefresh) {
      this.lastRefresh = this.refresh;
      this.getGradeClassList();
    }*/
    if (this.subjectList !== this.mySubjectList) {
      this.subjectList = this.mySubjectList;
      this.loaded = true;
    }
    if (this.assignmentList && this.assignmentList !== this.gradeList) {
      this.gradeList = this.assignmentList.slice();
    }
  }
 /*  ngAfterViewInit() {
    //this.updateSelectList();
  } */
  /* updateSelectList(){
    let options = this.selectElRef.nativeElement.options;
    for(let i=0; i < options.length; i++) {
      options[i].selected = this.selectedValues.indexOf(options[i].value) > -1;
    }

  } */
  getSchoolDetails(){
    this.schoolService.detail(this.school_id).subscribe(
      (response) => {    
       
        this.schoolDetails = response;
        console.log('school details Assign teacher :' + JSON.stringify(this.schoolDetails));
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }

  selectChange(teacher, classes,subjects, grade,sInd, cInd) {
   // this.currentClass = classes.name;
   var resultObject:boolean= false;
   //var index = this.selectedValues.findIndex(x => x.class_id === classes._id);  
   //alert("selectChange >>> "+this.gradeCount+"  : "+JSON.stringify(teacher)+" : "+ classes._id+" : "+subjects._id+" : "+grade.name+" : "+sInd)
   //alert(sInd+" : "+cInd) 
   if(this.selectedValues.some(person => person.class_id === classes._id)){
    resultObject=true;
   } else{
      resultObject=false;
   }
  /*  for(var subbject in this.gradeList[this.gradeCount-1].subjects){
     alert(JSON.stringify(subbject))
   } */
   var items=[];
   if(!resultObject){
   for(var i = 0; i <this.gradeList[this.gradeCount-1].subjects.length; i++){
    items.push(this.gradeList[this.gradeCount-1].subjects[i]);
   // alert(subjects._id+ " >>> "+this.gradeList[this.gradeCount-1].subjects[i]._id);
     if(subjects._id == this.gradeList[this.gradeCount-1].subjects[i]._id){
    /*   this.selectedValues[cInd].subjectteacher[i].subject_id = subjects._id;
      this.selectedValues[cInd].subjectteacher[i].teacher_id = teacher._id;
      this.selectedValues[cInd].subjectteacher[i].teacher_name = teacher.name; */
     
      //this.selectedValues.push({class_id:classes._id, name:classes.name, subjectteacher:[{subject_id:subjects._id, teacher_id:teacher._id, teacher_name:teacher.name}]})
    }else{
     // this.selectedValues[index].subjectteacher.push({subject_id:subjects._id, teacher_id:teacher._id, teacher_name:null});
     /*  this.selectedValues[cInd].subjectteacher[i].subject_id = subjects._id;
      this.selectedValues[cInd].subjectteacher[i].teacher_id = teacher._id;
      this.selectedValues[cInd].subjectteacher[i].teacher_name = null; */
      //this.selectedValues.push({class_id:classes._id, name:classes.name, subjectteacher:[{subject_id:subjects._id, teacher_id:teacher._id, teacher_name:null}]})
    } 
   
 }
}
// alert(JSON.stringify(this.selectedValues)+" >>> "+pos);
  
    /*  if(!resultObject){
      this.selectedValues.push({class_id:classes._id, name:classes.name, subjectteacher:[{subject_id:subjects._id, teacher_id:teacher._id, teacher_name:teacher.name}]})
      //alert("selectChange if >>> "+JSON.stringify(this.selectedValues));
    }
   else{   
      this.selectedValues[index].subjectteacher.push({subject_id:subjects._id, teacher_id:teacher._id, teacher_name:teacher.name});
      //alert("selectChange else >>> "+JSON.stringify(this.selectedValues));
   } */
    console.log("SelectedValues >>> "+JSON.stringify(this.selectedValues)); 
  }

  init() {

      forkJoin(
        this.userService.listRoles()
      ).subscribe(
        data => {
          this.roleListData = data[0];
          this.getTeacherList();
          this.getGradeClassList();
          this.getSchoolDetails();
        },
        err => console.error(err)
      );
  }
  prevGrade(){
   //alert(this.gradeCount)
    if(this.gradeCount > 0 &&  this.gradeCount<=(this.gradeList.length+1)){
      this.gradeCount = this.gradeCount-1;
      //alert(this.gradeCount)
      if(this.gradeCount == this.gradeList.length){
        this.btnText = 'Review';
        this.backText = 'Back'
      }else{
        this.btnText =  this.translate.instant('Next Grade');
      }  
      this.nextBtnClicked = false;   
    }
  }

  goToGrade(target){
    if(target > this.gradeCount){
      this.gradeCount = this.gradeCount+ (target - this.gradeCount);
      if(this.gradeCount == this.gradeList.length){
        this.btnText = 'Review';
        this.backText = 'Back'
      }else{
        this.btnText = this.translate.instant('Next Grade');
        this.backText = "Back"
      }


       if(this.gradeCount==(this.gradeList.length+1)){     
        this.nextBtnClicked = true;
        this.btnText = "Confirm";
        this.backText = "Edit";        
      }
       if(this.gradeCount>(this.gradeList.length+1)){
       
        this.nextBtnClicked = false;
        this.setupCompleted = true;
       // alert("else greater >>>> "+this.gradeCount+" >> "+this.nextBtnClicked);
        this.saveTeacherClass();
  
      }
    }else{
      this.gradeCount = this.gradeCount - (this.gradeCount - target);
      if(this.gradeCount == this.gradeList.length){
        this.btnText = "Review";
        this.backText = "Back"
      }else{
        this.btnText =  this.translate.instant('Next Grade');
      }  
    }
  }

  nextGrade(){
    //alert(this.gradeCount)
  
    if(this.gradeCount<=(this.gradeList.length+2)){

      this.gradeCount = this.gradeCount+1;
      if(this.gradeCount == this.gradeList.length){
        this.btnText = "Review";
        this.backText = "Back"
      }else{
        this.btnText =  this.translate.instant('Next Grade');
        this.backText = "Back"
      }


       if(this.gradeCount==(this.gradeList.length+1)){     
        this.nextBtnClicked = true;
        this.btnText = "Confirm";
        this.backText = "Edit";      
       // alert("confirmedit >>>> "+this.gradeCount+" >> "+this.nextBtnClicked);
  
      }
       if(this.gradeCount>(this.gradeList.length+1)){
       
        this.nextBtnClicked = false;
        this.setupCompleted = true;
      //  alert("else greater >>>> "+this.gradeCount+" >> "+this.nextBtnClicked);
        this.saveTeacherClass();
  
      }
    

    }
   
  }
  gotoStepComplete(){
   // window.localStorage.setItem('schoolSetupSuccess', this.school_id);
   this.titleMessage = "Skip Steps 4?";
  
  this.detailMessage2 = "Select OK to continue";
    this.setupCompleted = false;
   //alert("this.step >>>>> "+this.setupCompleted)
  /*  jQuery("#skipModal1").modal('show'); Janaki*/
  
  }
  cancelDelete(){
    jQuery("#skipModal1").modal('hide');
  }
  callCancelSetup(){
    this.isCancelSetup = true;
  }
showSetupComplete(){

  jQuery("#skipModal1").modal('hide');
  this.setupCompleted = true;
  

}
  finalStepForSetupYourSchool() {
    window.localStorage.setItem('schoolSetupSuccess', this.school_id);
    this.router.navigate(['/projectmanagement',this.project_id, this.school_id,'view'], {'relativeTo': this.route});
    
  }

  getGradeOldList() {
    this.schoolService.getGradeList(this.school_id).subscribe(
      (response) => {
        console.log('Grade List :' + JSON.stringify(response));
        this.gradeList = response;
        this.getSchoolDetails();
        //this.addGradesToForm();
        this.loaded = true;
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }

  getGradeClassList() {

    this.schoolService.getClassList(this.school_id).subscribe(
      (response) => {
       //console.log('Class List Teacher JANI >>> :' + JSON.stringify(response));
        const classList = response;
        for (const myclass of classList) {
          if ( this.gradeList && this.gradeList.map(function(e) { return e.name; }).indexOf(myclass.grade.name) === -1) {
            this.gradeList.push(myclass.grade);
          }
        }

        let i = 0;
        for (const grade of this.gradeList) {
          this.gradeList[i].classes = [];
          this.gradeList[i].subjects = [];
          classList.forEach(item => {
            if (item.grade && grade._id === item.grade._id) {
              if (!this.gradeList[i].subjects.length) {
                this.gradeList[i].subjects = item.subjects;
              }
              if (item.subjectteacher && Object.keys(item.subjectteacher[0]).length) {
                this.gradeList[i].subjectteacher = true;
              }
              if ( this.gradeList[i].classes.map(function(e) { return e.name; }).indexOf(item.name) === -1 ) {
                delete item.grade;
                delete item.subjects;
                this.gradeList[i].classes.push({'_id': item._id, 'name': item.name});
              }
            }
          });
          i++;
        }
        // this.addGradesToForm();
        //console.log('grade List JANAKI :' + JSON.stringify(this.gradeList[0]));
        this.loaded = true;
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }
show(){
  this.linkClicked =true;
}
  getRoleList() {
    //
    this.userService.listRoles().subscribe(
      (response) => {
        //console.log(' Full Response Role: ' + JSON.stringify(response));
        this.roleListData = response;
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log( 'COMPLETED' );
      }
    );
  }

  getRoleID(name: String) {

    //console.log('role name :' + name);
    if (this.roleListData.length) {
      for (let i = 0; i < this.roleListData.length; i++) {
        if (this.roleListData[i].name === name) {
          return this.roleListData[i]._id;
        }
      }
    }
    return;
  }

  getTeacherList() {
    // add filter
    const filterList = { sort_by: '_id', sort_order: 'desc', 'filter_by': 'school_id', 'filter_value': this.school_id };
    filterList.filter_by = filterList.filter_by + ',' + 'role_id';
    filterList.filter_value = filterList.filter_value + ',' + this.getRoleID('Teacher');

    this.userService.search(filterList).subscribe(
      (response) => {
        console.log('teacher list JANI >>> = ' + JSON.stringify(response));
        this.teachers = response;
        this.fillAssignedTeacherList(response);
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
       // console.log('done');
      }
    );
  }

  getSubjectList() {
    this.schoolService.getSubjectList().subscribe(
      (response) => {
       // console.log('Subject List :' + JSON.stringify(response));
        this.subjectList = response;
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      //console.log('COMPLETED');
      }
    );
  }

  enableGradeTab(i) {
    //
    let old = i - 1;
    if ( old < 1) {
      old = 0;
    }
    const tabOld = document.getElementById('tab_head_' + old);
    tabOld.classList.remove('active');
    const tabOldData = document.getElementById('tab_default_' + old);
    tabOldData.classList.remove('active');

    const tab = document.getElementById('tab_head_' + i);
    tab.classList.add('active');
    const tabData = document.getElementById('tab_default_' + i);
    tabData.classList.add('active');
    this.currentGrade = i;
  }

  myListFormatter(item: any): string {
    console.log('data ' + JSON.stringify(item));
    // return item.first_name+' '+item.last_name;
    if (item) {
      return `${item['name']}`;
    }
  }

  myValueFormatter(item: any): string {
    console.log('data ' + JSON.stringify(item));
    // return item.first_name+' '+item.last_name;
    if (item) {
      return `${item['name']}`;
    }
  }
  saveTeacherClass() {
    //
   // console.log('assignment ' + JSON.stringify(this.subjectTeacherAssigned));
     if (this.myForm.value) {
        //this.refreshAssignTeacher = false;
        let postData = [];
        //console.log(this.myForm.controls);
        this.myForm.value.subjectteacher.forEach(element => {
          console.log(element);
          let obj = {
            'grade_id': element.grade,
            'class_id': element.class,
            'subjectteacher': [
              {
                subject_id:element.subject._id,
                teacher_id: element.teacher._id
              }
            ]
          };
          postData.push(obj);
        });

        
        this.schoolManagementService.assignClassSubjectTeacher(postData, this.school_id).subscribe(
          (response) => {
            console.log('teacher assigned Response JANI :' + JSON.stringify(response));
            // jQuery('#assignsubjectModal').modal('hide');
          this.complete = true;
          },
          (err) => {
            console.log('ERROR: ' + err);
          },
          () => {
            //console.log('COMPLETED');
          /// this.refreshAssignTeacher = true;
            
          }
        );
     }
  }
  onAssignTeacher(vClass, vSubject, vTeacher) {

    console.log('class to assign --' + JSON.stringify(vClass));
    console.log('subject to assign --' + JSON.stringify(vSubject));
    console.log('teacher to assign --' + JSON.stringify(vTeacher));

    if (vClass && vSubject && vTeacher) {
      let i = -1;
      let j = -1;
      if (this.assignedTeacherList[vClass._id]) {
        i = this.assignedTeacherList[vClass._id].findIndex(x => x.class.name === vClass.name);
        j = this.assignedTeacherList[vClass._id].findIndex(x => x.subject.name === vSubject.name);
      } else {
        this.assignedTeacherList[vClass._id] = [];
      }
      // const k = this.assignedTeacherList.findIndex(x => x.teacher.name === vTeacher.name);
      // if (i === -1 && j === -1 && k === -1) {
      if (i === -1 || j === -1) {
        this.assignedTeacherList[vClass._id].push({'class': vClass, 'subject': vSubject, 'teacher': vTeacher});
        this.csubject = '';
        this.cteacher = '';
        this.enableComplete();
      } else {
        this.csubject = '';
        this.cteacher = '';
        return;
      }
    }
    return;
  }

  fillAssignedTeacherList(data) {
    this.assignedTeacherList = {};
    /*
    data.forEach(teacher => {
      teacher.classes.forEach(element => {
        if (element.class) {
          if (!this.assignedTeacherList[element.class._id]) {
            this.assignedTeacherList[element.class._id] = [];
          }
          const i = this.assignedTeacherList[element.class._id].findIndex(
            x => x.teacher.name === teacher.name &&
                x.subject.name === element.subject.name &&
                x.class.name === element.class.name
          );

          if ( i === -1 ) {
            this.assignedTeacherList[element.class._id].push({'class': element.class, 'subject': element.subject, 'teacher': teacher});
          }
        }
      });
    });*/
  }

  onAddAssignTeacher() {
    const data = {};
    console.log('assign pre data = ' + JSON.stringify(this.assignedTeacherList));
    if (this.assignedTeacherList) {
      Object.keys(this.assignedTeacherList).forEach(key => {
        const classmap = this.assignedTeacherList[key];
        classmap.forEach(item => {
          const teacher_id = item.teacher._id;
          const class_id = item.class._id;
          const subject_id = item.subject._id;
          if (!data[teacher_id]) {
            data[teacher_id] = [];
          }
          data[teacher_id].push({'class_id': class_id, 'subject_id': subject_id});
        });
      });
    }

    console.log('assign post data = ' + JSON.stringify(data));
    this.schoolService.assignTeacher(data).subscribe(
      (response) => {
        console.log('Assigned Successfully JANI:' + JSON.stringify(response));
        return true;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
      console.log('COMPLETED');
      }
    );
  }

  enableComplete() {
    Object.keys(this.assignedTeacherList).forEach(key => {
      if (this.assignedTeacherList[key] && this.assignedTeacherList[key].length) {
        this.assignDone.emit(true);
        return true;
      }
    });
    return false;
  }

  removeAssignment(class_id, value) {
    if (class_id && value) {
      this.assignedTeacherList[class_id].splice(value, 1);
    }
  }

  openAssignTeacher(grade,classSelected) {
    console.log("#####GRADE="+JSON.stringify(grade));
    console.log("#####Class Selected="+JSON.stringify(classSelected));
    grade.classSelected = classSelected;
    this.evOpenAssignTeacher.emit(grade);
    // console.log('clicked on grades');
  }
  
  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }
  ngOnDestroy() {
    let body = document.getElementsByTagName('body')[0];
    body.classList.remove("bodyBG");
  }
}